import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { getOptions } from '@ourbranch/lookups';
import { brandConfig } from 'brand-config';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const UPP_COVERAGE_ITEMS = [
  'moneyLimit',
  'jewelryLimit',
  'securitiesLimit',
  'motorizedVehiclesLimit',
  'silverwareLimit',
  'gunsLimit',
  'businessPropertyLimit'
];

const UnscheduledPersonalPropertyForm = ({ fieldName, disabled, state, riskType }) => {
  const classes = useStyles();
  const hiddenCoverages = brandConfig.farm[state]?.[riskType]?.hiddenCoverages || [];
  const shouldHideUNPP = UPP_COVERAGE_ITEMS.every((item) => hiddenCoverages.includes(item));

  if (shouldHideUNPP) {
    return null;
  }

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Unscheduled personal property</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.moneyLimit`}
          name={`${fieldName}.moneyLimit`}
          mode="dark"
          label="Money"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.securitiesLimit`}
          name={`${fieldName}.securitiesLimit`}
          mode="dark"
          label="Securities"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.motorizedVehiclesLimit`}
          name={`${fieldName}.motorizedVehiclesLimit`}
          mode="dark"
          label="Motorized vehicles"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.jewelryLimit`}
          name={`${fieldName}.jewelryLimit`}
          mode="dark"
          label="Jewelry, watches, and furs"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.silverwareLimit`}
          name={`${fieldName}.silverwareLimit`}
          mode="dark"
          label="Silverware"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.gunsLimit`}
          name={`${fieldName}.gunsLimit`}
          mode="dark"
          label="Guns"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
        <Field
          xs={4}
          type="select"
          id={`${fieldName}.businessPropertyLimit`}
          name={`${fieldName}.businessPropertyLimit`}
          mode="dark"
          label="Business property"
          disabled={disabled}
          options={[
            { id: 0, value: 'None' },
            { id: 500, value: '$500' },
            { id: 1500, value: '$1,500' },
            { id: 2000, value: '$2,000' },
            { id: 5000, value: '$5,000' }
          ]}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

UnscheduledPersonalPropertyForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

UnscheduledPersonalPropertyForm.defaultProps = {
  disabled: false
};

export default observer(UnscheduledPersonalPropertyForm);
